import { stepDirFromPath } from "../../shared/stepConfig";
import { isStepTestInputRelPath } from "../../shared/stepTests/constants";

// Step dirs that have at least one pinned step-test input to replay,
// derived from a commit's full file paths.
export function stepDirsWithStepTests(
  files: readonly { path: string }[]
): string[] {
  const dirs = new Set<string>();
  for (const f of files) {
    const dir = stepDirFromPath(f.path);
    if (dir && isStepTestInputRelPath(f.path.slice(dir.length + 1)))
      dirs.add(dir);
  }
  return [...dirs].toSorted();
}
